import React from "react"
import { AgTechApplication } from "../app/AgTechApplication"
import { useAgTechQuery } from "../data/queries/AgTechDataQueries"

const DefaultFeatureEnabled = false;

export type AgTechEnabledFeature = {
    name: string
}

export type AgTechPublicFeature = {
    id: string,
    name: string,
    description: string,
    isEnabled: boolean
}

export type AgTechFeatureContextType = {
    isFeatureEnabled: (featureName: string) => boolean
}

const AgTechFeatureContextInstance = React.createContext<AgTechFeatureContextType>({
    isFeatureEnabled: () => DefaultFeatureEnabled
});

export const useAgTechFeatureContext = () => React.useContext(AgTechFeatureContextInstance);

type AgTechFeatureContextProps = {
    app: AgTechApplication,
    children: React.ReactNode
}

export const AgTechFeatureContext = (props: AgTechFeatureContextProps) => {
    const featureQuery = useAgTechQuery({
        query: props.app.features.query
    });

    const features = featureQuery.queryResult?.data ?? [];

    const featureContext: AgTechFeatureContextType = {
        isFeatureEnabled: (featureName: string) => features.some(f => f.name === featureName)
    }

    return (
        <AgTechFeatureContextInstance.Provider value={featureContext}>
            {props.children}
        </AgTechFeatureContextInstance.Provider>
    )
}